<template>
  <div class="auth-page">
    <!-- 忘記密碼表單 -->
    <section class="auth-section">
      <div class="container">
        <div class="auth-card">
          <h2 class="auth-title">忘記密碼</h2>
          <p class="auth-description">
            請輸入您的電子郵件，我們將發送重設密碼的連結給您
          </p>

          <form @submit.prevent="handleForgotPassword" class="auth-form">
            <!-- 電子郵件 -->
            <div class="form-group">
              <label for="email">電子郵件</label>
              <div class="input-wrapper">
                <i class="fas fa-envelope input-icon"></i>
                <input
                  type="email"
                  id="email"
                  v-model="form.email"
                  placeholder="請輸入您的電子郵件"
                  required
                />
              </div>
              <span v-if="errors.email" class="error">{{ errors.email }}</span>
            </div>

            <!-- 驗證碼 -->
            <div class="form-group">
              <label for="captcha">驗證碼</label>
              <div class="captcha-wrapper">
                <div class="input-wrapper">
                  <i class="fas fa-shield-alt input-icon"></i>
                  <input
                    type="text"
                    id="captcha"
                    v-model="form.captcha"
                    placeholder="請輸入驗證碼"
                    required
                  />
                </div>
                <div class="captcha-display">
                  <span>{{ captchaCode }}</span>
                  <button
                    type="button"
                    @click="refreshCaptcha"
                    class="refresh-btn"
                  >
                    <i class="fas fa-sync-alt"></i>
                  </button>
                </div>
              </div>
              <span v-if="errors.captcha" class="error">{{
                errors.captcha
              }}</span>
            </div>

            <!-- 提交按鈕 -->
            <button type="submit" class="send">發送重設連結</button>

            <!-- 其他連結 -->
            <p class="auth-link">
              <router-link to="/login" class="link">返回登入</router-link>
            </p>
            <p class="auth-link">
              還沒有帳號？<router-link to="/register" class="link"
                >立即註冊</router-link
              >
            </p>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script src="@/assets/js/forgot.js"  defer></script>

<style scoped src="@/assets/css/forgot.css"></style>
